import * as React from 'react';
var SummaryContext = /*#__PURE__*/React.createContext({});
export default SummaryContext;